import dateStartOfDay from 'date-fns/startOfDay';

const mixin = {
  computed: {
    quarterDisabledDates() {
      const currentDate = dateStartOfDay(new Date());
      const currentYear = currentDate.getFullYear();

      if (currentDate < new Date(`${currentYear}-01-15`)) return { to: new Date(`${currentYear - 1}-10-15`) };
      if (currentDate < new Date(`${currentYear}-04-15`)) return { to: new Date(`${currentYear}-01-15`) };
      if (currentDate < new Date(`${currentYear}-07-15`)) return { to: new Date(`${currentYear}-04-15`) };
      if (currentDate < new Date(`${currentYear}-10-15`)) return { to: new Date(`${currentYear}-07-15`) };
      return { to: new Date(`${currentYear}-10-15`) };
    },
  },
};

export default mixin;
